import React from 'react'
import { useDispatch } from 'react-redux'
import styles from '../component-styles/calendar-side-bar.module.scss'
import DateDetails from './calendar-date-details'
import Filters from './calendar-filters'
import { startOfYear, endOfMonth, formatForAPI } from '../helpers/dates'

import {
  getCalendarEventsAsync,
  getCalendarCampaignsAsync,
} from '../store/actions'
import KPIS from './calendar-kpis'

interface Props {
  sideBarActive: boolean
  kpiMetrics: Kpi[]
  setSelectedKpi: () => void
  selectedKpi: string
  day: DayCalendarItem
  filters: {
    anomalies: boolean
    campaigns: boolean
    events: boolean
  }
  gaCampaigns: string[]
  toggleFilter: (s: string) => void
  mobile?: boolean
  width: number
  height?: number
  setSideBarActive: (e: any) => void
  setDay: (e: any) => void
}

export default function CalendarSideBar({
  sideBarActive,
  kpiMetrics,
  setSelectedKpi,
  selectedKpi,
  day,
  filters,
  gaCampaigns,
  toggleFilter,
  mobile,
  width,
  height,
  setSideBarActive,
  setDay,
}: Props): React.ReactElement | null {
  const dispatch = useDispatch()

  // prevent mobile version from showing at desktop
  if (width >= 768 && mobile) {
    return null
  }

  // prevent desktop version from showing at mobile
  if (width < 768 && !mobile) {
    return null
  }

  return (
    <div
      className={sideBarActive ? styles.sideBar : styles.sideBarClosed}
      style={{ maxHeight: height }}
    >
      <button
        onClick={(): void => {
          setSideBarActive(!sideBarActive)
          // to reset the day after the sidebar is hidden
          setTimeout((): void => setDay(null), 500)
        }}
        className={
          sideBarActive ? styles.sideBarButton : styles.sideBarButtonClosed
        }
        type="button"
      >
        <span className={styles.first} />
        <span className={styles.second} />
      </button>
      <p className={styles.description}>Options &amp; detail</p>
      <div className={styles.innerSideBar}>
        <KPIS
          kpis={kpiMetrics}
          setSelected={setSelectedKpi}
          selected={selectedKpi}
        />
        <Filters
          {...filters}
          day={day !== null ? day.date : null}
          onEventsToggle={(): void => toggleFilter('events')}
          onAnomaliesToggle={(): void => toggleFilter('anomalies')}
          onCampaignsToggle={(): void => toggleFilter('campaigns')}
        />
        <DateDetails
          date={day !== null ? day.date : null}
          events={day !== null ? day.events : null}
          anomalies={day !== null ? day.anomalies : null}
          campaigns={day !== null ? day.campaigns : null}
          onSuccessfullyAddingEvent={(): ReduxAction =>
            dispatch(
              getCalendarEventsAsync({
                fromDate: formatForAPI(startOfYear()),
                toDate: formatForAPI(endOfMonth()),
              }),
            )
          }
          onSuccessfullyCreatingCampaign={(): ReduxAction =>
            dispatch(
              getCalendarCampaignsAsync({
                fromDate: formatForAPI(startOfYear()),
                toDate: formatForAPI(endOfMonth()),
              }),
            )
          }
          gaCampaigns={gaCampaigns}
        />
      </div>
    </div>
  )
}
